export default "__VITE_ASSET__AnLia23M__"